import { useMutation } from '@tanstack/react-query';

import {
  FoodBusinessSubmitRequest,
  submitFoodBusinessForm,
} from '../api/foodBusiness';

/** Submit community signup or Pawdit demo requests through the shared lead endpoint. */
export const useSubmitFoodBusinessForm = () => {
  const mutation = useMutation({
    mutationFn: async (payload: FoodBusinessSubmitRequest) => {
      return submitFoodBusinessForm(payload);
    },
  });

  const submitFoodBusiness = (payload: FoodBusinessSubmitRequest) =>
    mutation.mutateAsync(payload);

  return {
    submitFoodBusiness,
    isSubmittingFoodBusiness: mutation.isPending,
    resetFoodBusinessSubmit: mutation.reset,
  };
};
